module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_75_optimized.026d34a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/thumbnail/writingjapaneseanimal_75_optimized.jpg
// module id = Q3rP
// module chunks = 0